// extracted by mini-css-extract-plugin
export var centerList = "_jc-6";
export var centerLoc = "_jc-a";
export var centerName = "_jc-9";
export var centerOptionBody = "_jc-8";
export var centerRow = "_jc-7";
export var centerStatus = "_jc-b";
export var empty = "_jc-5";
export var externalIcon = "_jc-c";
export var fieldHeader = "_jc-2";
export var fieldHelp = "_jc-4";
export var fieldLabel = "_jc-3";
export var panel = "_jc-0";
export var removeBtn = "_jc-d";
export var section = "_jc-1";